import NutritionalInformation from './NutritionalInformation'

export default NutritionalInformation
